import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import * as catalogApi from '@api/catalog'
import * as S from './SaleLink.styled'

const SaleLink = () => {
    const [saleCount, setSaleCount] = useState()

    useEffect(() => {
        const initPromotionCount = async () => {
            const promotionsCount = await catalogApi.getPromotionsCount()
            setSaleCount(promotionsCount)
        }
        initPromotionCount()
    }, [])
    return (
        <Link href="/catalog/promotion/list" passHref legacyBehavior>
            <S.Container>
                <S.IconContainer>
                    <S.Image />
                </S.IconContainer>
                <S.Title>Скидки и акции {saleCount ? `(${saleCount})` : ''}</S.Title>
            </S.Container>
        </Link>
    )
}

export default SaleLink
